import React  from 'react';
export const DateView = props => {
    if (props.value === "0001-01-01T00:00:00") {
        return null;
    }
    const d = new Date(props.value);
    return <>{d.toLocaleDateString()}</>;
};